import { EquipmentItem } from "@/backend/models/equipmentItem";
import { useState } from "react";
import { useEquipmentStore } from "@/frontend/store/EquipmentStore";
import { ButtonParent } from "../buttons/ButtonParent";
import { I18n } from "@/i18n/I18n";
import { EquipmentItemCreateData } from "@/types/equipmentTypes";
import { PencilSquare } from "@/frontend/SVGs/PencilSquare";
import { EquipmentItemModal } from "./EquipmentItemModal";

export function EditEquipmentModal(props: { equipmentItem: EquipmentItem }) {
  const { equipmentItem } = props;
  const [show, setShow] = useState(false);
  const updateEquipment = useEquipmentStore(state => state.updateEquipment);

  const onConfirm = async (item: EquipmentItemCreateData) => {
    const result = await updateEquipment({ ...item, id: equipmentItem.id, defaultConfiguration: equipmentItem.defaultConfiguration });
    return result;
  };

  return (
    <>
      <ButtonParent
          className="btn btn-sm btn-warning"
          onClick={() => setShow(true)}
          title={I18n.get('editModel', { model: I18n.get('equipment'), title: equipmentItem.name })}
          >
          <PencilSquare />
      </ButtonParent>
      { show && <EquipmentItemModal equipmentItem={equipmentItem} setShow={setShow} onConfirm={onConfirm} /> }
    </>
  );
}
